'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/network.png'




const PeakMain = () => {
    // State to hold dynamic content
    const [serviceDetails] = useState({
        title: "Network Security for every context",
        text1: "Creating content focused on network security involves educating and informing your audience about the importance of securing their networks from various cyber threats. Here are some content ideas tailored to network security:",
        image1: ServiceDetailsImg,
        title2: "1. Network Security: Fortify Your Digital Infrastructure",
        text2: "Techtotalers is dedicated to providing advanced network security solutions that safeguard your digital infrastructure. Our comprehensive guide explores best practices, emerging trends, and real-world case studies to help you build a resilient network security posture.",
        content3Title: "2. Advanced Network Security Strategies",
        text3: (
            <>
                <b>Microsegmentation:</b> Isolating critical systems to minimize the impact of breaches.<br />
                <b>Behavioral Analytics:</b> Leveraging machine learning to detect unusual network activities.<br />
                <b>Zero-Trust Architecture:</b> A security model requiring continuous verification for all access requests.<br />
            </>
        ),
        content4Title: "3. Protecting Against Insider Threats",
        text4:  (
            <>
                <b>Insider threats pose significant risks due to authorized access. Learn how to:</b> Implement access controls, data encryption, and monitoring to mitigate these threats.<br>
                </br>Detect and respond to suspicious activities within your network.
                </>
        ),
        content5Title: "4. Securing IoT Devices in Your Network",
        text5: 
        (
            <>
                <b>IoT devices introduce new security challenges. Our guide offers best practices including:</b> Strong authentication measures and access controls for IoT devices.<br>
                </br> Regular firmware updates to address security vulnerabilities. <br>
                </br>Network segmentation to isolate IoT devices from critical assets.<br>
                </br>
                </>
        ),
        content6Title: "5. Emerging Trends in Network Security",
        text6: 
        (
            <>
                <b>Stay ahead with insights on the latest trends shaping network security: </b>  The role of Artificial Intelligence (AI) in threat detection and response.<br>
                </br> Quantum computing's potential impact on traditional encryption methods. <br>
                </br> Security considerations for 5G networks and connected devices.<br>
                </br>
                </>
        ),
        content7Title: "6. Comprehensive Resources and Case Studies",
        text7:
        (
            <>
                <b>Whitepapers and E-books: </b>  Dive deep into network security frameworks, cloud security best practices, and remote workforce protection strategies.<br>
                </br>
                <b>Case Studies:</b>Real-world examples demonstrating how Techtotalers’ security solutions have helped businesses prevent data breaches and secure sensitive information.
                </>
        ),
        features: [
            {
                icon: "icon-crane-1",
                title: "Reliable Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
            {
                icon: "icon-buildings",
                title: "Building Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
        ],
    });

    return (
        <React.Fragment>
            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">
                                    <h2 className="service-details__title-one">{serviceDetails.title}</h2>
                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    <div className="service-details__img-one">
                                        <img src={serviceDetails.image1} alt="" />
                                    </div>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <p className="service-details__text-3">{serviceDetails.text2}</p>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.content3Title}</h4>
                                    <p className="service-details__text-3">{serviceDetails.text3}</p>  
                                </div>
                                <div className="service-details__content-four">
                                    <h4 className="service-details__title-two">{serviceDetails.content4Title}</h4>
                                    <p className="service-details__text-3">{serviceDetails.text4}</p>
                                </div>
                                <div className="service-details__content-four">
                                    <h4 className="service-details__title-two">{serviceDetails.content5Title}</h4>
                                    <p className="service-details__text-3">{serviceDetails.text5}</p>
                                </div>
                                <div className="service-details__content-four">
                                    <h4 className="service-details__title-two">{serviceDetails.content6Title}</h4>
                                    <p className="service-details__text-3">{serviceDetails.text6}</p>
                                </div>
                                <div className="service-details__content-four">
                                    <h4 className="service-details__title-two">{serviceDetails.content7Title}</h4>
                                    <p className="service-details__text-3">{serviceDetails.text7}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="service-details__sidebar">
                                <div className="service-details__service-list-box">
                                <h4 className="service-details__sidebar-title">Main Service</h4>
                                <ul className="service-details__service-list list-unstyled">
                                    <li className="">
                                    <Link to="/security-consulting">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Security Consulting
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/audit-&-compliance">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Audit & Compliance
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/cloud-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Cloud Security
                                    </Link>
                                    </li>
                                    <li className="active">
                                    <Link to="/network-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Network Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/design-&-implementation">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Design & Implementation
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/managed-it-services">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Managed IT Services
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/ot-iot-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        OT, IoT Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/api-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        API Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/offensive-security-red-teaming">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Offensive Security, Red Teaming
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/vulnerability-assessment">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Vulnerability Assessment
                                    </Link>
                                    </li>                                </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default PeakMain;
